import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Service {
    constructor() {
        this.init();
    }

    init() {
        this.eventBind();
    }

    eventBind() {
        const fullposts = [...document.querySelectorAll('.js-service_fullpost')];
        const navLinks = [...document.querySelectorAll('.c-archive__category__list__item a')];

        fullposts.forEach((elm, index) => {
            const changeCurrent = () => {
                const fullpostId = elm.id;
                document.body.dataset.current = fullpostId;

                navLinks.forEach((link) => {
                    const linkHref = link.href.split('#').pop(); // ハッシュを分割して末尾を取得
                    if (linkHref.includes(fullpostId)) {
                        link.setAttribute('data-active', '1');
                    } else {
                        link.removeAttribute('data-active');
                    }
                });
            };

            const scrollTriggerOptions = {
                trigger: elm,
                start: index === 0 ? 'top bottom' : 'top center', // 最初の要素だけ 'top bottom' を使用
                end: 'bottom center',
                // markers: true,
                onEnter: () => changeCurrent(),
                onEnterBack: () => changeCurrent(),
            };

            ScrollTrigger.create(scrollTriggerOptions);
        });
    }
}
